import type { IAlbumSettingsResponse, IAlbumSettingsResponseV1 } from "@/types"

export class AlbumSettings {
  hideGuestbook: boolean = false
  disableUploads: boolean = false
  sharePix: boolean = true
  streamingAllowed: boolean = true
  shareGuestbook: boolean = true
  allowDownloads: boolean = false
  allowGuestShare: boolean = false

  constructor(settings?: Partial<AlbumSettings>) {
    this.disableUploads = settings?.disableUploads ?? false
    this.hideGuestbook = settings?.hideGuestbook ?? false
    this.sharePix = settings?.sharePix ?? true
    this.streamingAllowed = settings?.streamingAllowed ?? true
    this.shareGuestbook = settings?.shareGuestbook ?? true
    this.allowDownloads = settings?.allowDownloads ?? false
    this.allowGuestShare = settings?.allowGuestShare ?? false
  }

  public static fromResponse(response?: IAlbumSettingsResponse): AlbumSettings {
    return new AlbumSettings({
      disableUploads: response?.DisableGuestUpload,
      hideGuestbook: response?.HideGuestbook,
      sharePix: response?.SharePixWithGuests ?? true,
      streamingAllowed: response?.StreamingAllowed,
      shareGuestbook: response?.ShareGuestbookWithGuests,
      allowDownloads: response?.AllowGuestDownload,
    })
  }

  public static fromResponseV1(response?: IAlbumSettingsResponseV1): AlbumSettings {
    return new AlbumSettings({
      disableUploads: response?.disableGuestUpload,
      hideGuestbook: response?.hideGuestbook,
      sharePix: response?.sharePixWithGuests ?? true,
      streamingAllowed: response?.streamingAllowed,
      shareGuestbook: response?.shareGuestbookWithGuests,
      allowDownloads: response?.allowGuestDownload,
      allowGuestShare: response?.allowGuestShare,
    })
  }
}
